export default "__VITE_ASSET__V57aojqW__"